import { updateObject } from "../../../../shared";
import { globalConstants } from "../../constants";
import { GET_BRAND_REPORT } from "../actions/brandReport.actions";

const { SUCCESS, FAILURE } = globalConstants;

const initialState = {
  brandReport: {
    pos: null,
    online: null,
  },
};

export const brandReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BRAND_REPORT + SUCCESS:
      return updateObject(state, {
        brandReport: action.data,
      });

    case GET_BRAND_REPORT + FAILURE:
      return updateObject(state, {
        brandReport: initialState.brandReport,
      });

    default:
      return state;
  }
};
